import React from 'react'
import PropTypes from 'prop-types'
import TableRow from './TableRow'

const TableBody = ({ columnList, objectList, idProperty, onRowClick, onRowDoubleClick, hiddenColumns }) => {
    return (
        <tbody>
            {objectList.map((row, index) => {
                return (
                    <TableRow
                        columnList={columnList}
                        row={row}
                        key={row[idProperty]}
                        onRowClick={onRowClick}
                        onRowDoubleClick={onRowDoubleClick}
                        hiddenColumns={hiddenColumns}
                    />
                )
            })}
        </tbody>
    )
}

TableBody.propTypes = {
    columnList: PropTypes.array.isRequired,
    objectList: PropTypes.array.isRequired,
    idProperty: PropTypes.string.isRequired,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
}

export default TableBody



// WEBPACK FOOTER //
// ./src/modules/table/component/TableBody.js